var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandClickActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.893,
    height: 24.3,
    viewBox: "0 0 16.893 24.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0885d5;stroke:#0885d5;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1108.35 -221.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.167 0.765)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.839,21.212v-1.56a4.481,4.481,0,1,1,7.126-2.821l1.243.5a5.78,5.78,0,1,0-8.369,3.878Z",
    transform: "translate(1110.89 210.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.14,28.941a4.867,4.867,0,0,0-.662-2.029,1.9,1.9,0,0,0-1.665-.738,2.705,2.705,0,0,0-.305.017l-.091.016,0-.036a1.74,1.74,0,0,0-.39-.815,1.543,1.543,0,0,0-.745-.451,3.22,3.22,0,0,0-.877-.1,2.6,2.6,0,0,0-.472.042l-.419.123-.091-.277a1.491,1.491,0,0,0-.992-.829,3.22,3.22,0,0,0-.877-.1,2.6,2.6,0,0,0-.473.042l-.229.067,0-1.348v0h0V22.5h0a2.2,2.2,0,0,0-2.1-2.194,2.138,2.138,0,0,0-2.066,2.211v5.573l-.2.029a2.705,2.705,0,0,0-2.21,2.092,4.641,4.641,0,0,0,.716,3.394c1.349,2.135,2.818,4.066,2.968,6.6a.6.6,0,0,0,.588.577l7.369.034a.6.6,0,0,0,.589-.528C36.883,37.541,39.761,33.143,39.14,28.941Zm-3.7,10.59-.01.058-6.342-.03-.079-.5c-.465-2.434-1.924-4.385-3.026-6.128a3.393,3.393,0,0,1-.554-2.432,1.449,1.449,0,0,1,.984-1.088l.276-.076v2.222a.593.593,0,1,0,1.184,0V22.536a.9.9,0,0,1,.881-.915c.774,0,.892.81.916,1.031L29.653,28.3a.592.592,0,1,0,1.184,0l.008-3.081.056-.056a1.052,1.052,0,0,1,.649-.181c.548,0,.7.1.755.159s.162.272.14.939l-.02,2.149a.593.593,0,1,0,1.184.011l.022-1.916a.919.919,0,0,1,.769-.3c.549,0,.7.1.754.159s.162.271.14.939l-.019,2.149a.592.592,0,1,0,1.184.011l.018-1.85a1.4,1.4,0,0,1,.336-.038c.467,0,.617.11.722.252a3.8,3.8,0,0,1,.437,1.485C38.5,32.7,36.089,36.535,35.437,39.531Z",
    transform: "translate(1109.052 204.415)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandClickActive);
export default __webpack_public_path__ + "static/media/hand-click-active.29f876026a9b62075f3201e606de7b24.svg";
export { ForwardRef as ReactComponent };